// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18X2w","image":"Header_image__3nMo-","name":"Header_name__1zCi9","info":"Header_info__fNdXM","infoRow":"Header_infoRow__i041L"};